exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".gcic-logo[data-v-e6ef8ce6]{display:block;height:82px;margin:auto;margin-left:auto;margin-right:auto;margin-bottom:50px}.bottom-container[data-v-e6ef8ce6]{position:fixed;left:0;bottom:0;width:100%;color:#fff;text-align:center;z-index:9999}.nav-button[data-v-e6ef8ce6]{display:inline-block;padding:5px 15px;margin-left:13px;margin-right:13px;border:2px solid #000;border-radius:10px;background-color:#fff;-webkit-transition-duration:.4s;transition-duration:.4s}.nav-button[data-v-e6ef8ce6]:hover{background-color:grey}.left-button[data-v-e6ef8ce6]{float:left}.right-button[data-v-e6ef8ce6]{float:right}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e6ef8ce6","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/gcicPage.vue
// module id = 205
// module chunks = 0